import { render } from "./PaymentSuccessModal.vue?vue&type=template&id=36ab8882&scoped=true"
import script from "./PaymentSuccessModal.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessModal.vue?vue&type=script&lang=js"

import "./PaymentSuccessModal.vue?vue&type=style&index=0&id=36ab8882&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ab8882"]])

export default __exports__